import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center py-16" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "The page you're looking for does not exist.", -1)

import RouterButton from "@/components/RouterButton.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createVNode(RouterButton, {
        to: { name: 'Dashboard' },
        type: "primary",
        class: "mx-auto mt-4"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Back to Dashboard")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})